import type { WebSocketState } from "@/types";

import { mutations } from "./mutations";
import { actions } from "./actions";
import { getters } from "./getters";

export const webSocketState: WebSocketState = {
  wsData: null,
  ws: null,
  uploadManualData: false,
  wsValidateData: null,
};

export const WebSocketModule = {
  namespaced: true,
  state: webSocketState,
  actions,
  mutations,
  getters,
};
